import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/auth/actions';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function SignOut() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const accessToken = useSelector(state => state.Auth.accessToken);

    useEffect(() => {
        if (accessToken) {
            dispatch(logout());
            navigate('/');
        }
    }, [accessToken, dispatch, navigate]);

    return (
        <div className="container min-vh-100">
            <h1>{t('logout')}</h1>
        </div>
    )
}

export default SignOut;
